

































































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import basicPage from "@/layouts/basicPage.vue";
import AppConsts from "@/lib/appconst";
import ajaxHelperInstance from "@/lib/ajaxhelper";
// import key from "ant-design-vue/es/vc-table/demo/key";


@Component({
  components: {basicPage}
})
export default class allTrain extends basicPage {
  /**
   * yjr开始
   * ***/
      //变量
  pageSize: 10;   //每页行数
  current: 1;//页数
  dataList: Array<Object> = [];//数据集合


  /**
   * yjr结束
   * ***/



  customActiveKey = '0'
  data: Array<Object> = [];

  handleTabClick(e) {
    this.customActiveKey = e;
  }

  pagination = {
    ...AppConsts.pagination,
    onChange: (current) => {
      this.pagination.current = current;
      this.loadData();
    }, onShowSizeChange: (current, pageSize) => {
      this.pagination.pageSize = pageSize;
      this.pagination.current = current;
      this.loadData();
    }
  };

  parameters = {
    keyWords: '',  //模糊查询字段
    page: this.pagination.current,
    pageSize: this.pagination.pageSize,
    assignState: null, //培训状态
    isPage: true
  };


  loadData() {
    let self = this;
    this.parameters.page = this.pagination.current;
    this.parameters.pageSize = this.pagination.pageSize;
    const queryParameters = {...this.parameters};
    ajaxHelperInstance.get('/web/meeting/search/getMeettingList', queryParameters, undefined, this).then((res) => {
      self.data = res.data.data.list;
      self.pagination.total = res.data.data.total;
    })
  }

  setKeywordsAndLoad(keywords) {
    this.parameters.keyWords = keywords;
    this.pagination.current = 1;
    this.loadData();
  }

  handleStateChange(e) {
    this.pagination.current = 1;
    this.parameters.assignState = e;
    this.loadData();
  }

  //主题图片
  getThemeImgUrl(obj) {
    let url = obj.ztimg;
    if (url == null || url == undefined) {
      url = "/img/training/trainBack.svg"
    } else {
      url = AppConsts.fileResourceUrl + url;
    }
    return url;
  }

  //状态图片
  getPXImageUrl(item) {
    let ret = ''
    switch (item.pxstatus) {
      case 1: { //报名未开始
        ret = '/img/training/wks.png';
        break;
      }
      case 2: { //报名中
        ret = '/img/training/zzbm.png';
        break;
      }
      case 3: { //报名结束
        ret = '/img/training/yjs.png';
        break;
      }
      case 4: { //培训结束
        ret = '/img/training/pxjs.png';
        break;
      }
    }
    return ret;
  }

  //培训详情展示--路由跳转
  viewTrain(item) {
    this.$router.push({
      name: 'trainDetail',
      params: {
        trainId: item.pxid
      }
    })
  }


  mounted() {
    this.loadData();
  }
}
